import { Actions } from "./Actions";

export const dispatchSetInfraType = (details) => {
  return { type: Actions.GET_INFRA_TYPE, details };
};
